import './styles.scss';

import React from 'react';

const { Component } = React;

class BlogPostPreview extends Component {
  render() {
    const { title, excerpt, slug } = this.props;

    return (
      <div className="col-12 col-md-4 mb-4">
        <div className="card blog-post-preview">
          <div className="card-header font-weight-bold">
            {title.substring(0, 35)}
          </div>
          <div className="card-body text-left">
            {excerpt}
          </div>
          <div className="card-footer bg-white border-0 text-left">
            <a href={slug} className="card-link">Read More...</a>
          </div>
        </div>
      </div>
    );
  }
};

export default BlogPostPreview;
